import { Code2, Github, Mail, MapPin } from "lucide-react";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-grain border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[hsl(var(--accent-magenta))] mb-3">
          // section_03
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight leading-none mb-12">
          Sobre mí
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Terminal block */}
          <div
            data-testid="about-terminal"
            className="lg:col-span-8 glass overflow-hidden"
          >
            {/* terminal title bar */}
            <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-card/50">
              <div className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-[hsl(var(--accent-magenta))]" />
                <span className="w-3 h-3 rounded-full bg-yellow-500" />
                <span className="w-3 h-3 rounded-full bg-[hsl(var(--accent-green))]" />
              </div>
              <div className="font-mono text-xs text-muted-foreground ml-2">
                ~/dvassallo — zsh — 80×24
              </div>
            </div>

            {/* terminal body */}
            <div className="p-6 md:p-8 font-mono text-sm md:text-base leading-relaxed">
              <Line prompt="$" cmd="whoami" />
              <p className="text-foreground mb-5 pl-4">
                Daniel Vassallo · Full-Stack Developer
              </p>

              <Line prompt="$" cmd="cat about.md" />
              <pre className="text-muted-foreground whitespace-pre-wrap mb-5 pl-4">
{`# Sobre mí

Construyo aplicaciones web full-stack pensadas para resolver
problemas reales: desde herramientas para procesar PDFs en lote,
hasta sistemas de tickets y apps de salud.

Este sitio es mi vidriera: un único lugar para probarlas todas.`}
              </pre>

              <Line prompt="$" cmd="ls stack/" />
              <div className="pl-4 mb-5 flex flex-wrap gap-x-6 gap-y-1 text-[hsl(var(--accent-cyan))]">
                {[
                  "react",
                  "fastapi",
                  "mongodb",
                  "tailwind",
                  "python",
                  "node",
                  "docker",
                ].map((s) => (
                  <span key={s}>{s}/</span>
                ))}
              </div>

              <Line prompt="$" cmd="echo $STATUS" />
              <p className="text-[hsl(var(--accent-green))] pl-4 mb-5">
                disponible para nuevos proyectos
              </p>

              <Line prompt="$" cmd="" cursor />
            </div>
          </div>

          {/* Side cards */}
          <div className="lg:col-span-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
            <InfoCard
              icon={<Code2 size={18} />}
              label="enfoque"
              value="Producto + DX"
              testId="about-info-focus"
              accent="green"
            />
            <InfoCard
              icon={<MapPin size={18} />}
              label="ubicación"
              value="Argentina"
              testId="about-info-location"
              accent="cyan"
            />
            <InfoCard
              icon={<Mail size={18} />}
              label="contacto"
              value="ver sección abajo"
              testId="about-info-contact"
              accent="magenta"
            />
            <InfoCard
              icon={<Github size={18} />}
              label="domain"
              value="dvassalloapps.com.ar"
              testId="about-info-domain"
              accent="green"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Line = ({ prompt, cmd, cursor }) => (
  <div className="flex items-baseline gap-2 mb-1">
    <span className="text-[hsl(var(--accent-green))]">{prompt}</span>
    <span className={cursor ? "cursor-blink" : ""}>{cmd}</span>
  </div>
);

const accentMap = {
  green: {
    icon: "text-[hsl(var(--accent-green))]",
    border: "hover:border-[hsl(var(--accent-green)/0.5)]",
  },
  cyan: {
    icon: "text-[hsl(var(--accent-cyan))]",
    border: "hover:border-[hsl(var(--accent-cyan)/0.5)]",
  },
  magenta: {
    icon: "text-[hsl(var(--accent-magenta))]",
    border: "hover:border-[hsl(var(--accent-magenta)/0.5)]",
  },
};

const InfoCard = ({ icon, label, value, testId, accent = "cyan" }) => {
  const a = accentMap[accent] || accentMap.cyan;
  return (
    <div
      data-testid={testId}
      className={`glass p-5 hover-lift ${a.border}`}
    >
      <div className={`mb-3 ${a.icon}`}>{icon}</div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">
        {label}
      </div>
      <div className="font-display font-bold text-lg break-words">{value}</div>
    </div>
  );
};

export default About;
